<template>
  <section class="basic-instance">
    <el-form size="small"  :model="schemaData" :rules="schemaRules" ref="ruleFormRef">
      <el-card class="card">
        <div slot="header">
          <strong style="font-size: 14px">{{ schemaBasicInfo.label }}</strong>
        </div>

        <div>
          <schema-form :model="schemaData" :layout="layout" :schema="schemaConfig" :options="schemaOptions">
            <!-- <template v-for="(t,i) in ['welcome', 'hello']"   :slot="`fileTagsSlot${t}`" > -->
            <template v-for="(t,i) in schemaBasicInfo.tagSlotArr"   :slot="`fileTagsSlot${t}`" >
              <!-- 新建 tag -->
              <el-form-item :label="`tag - ${t}`" :key="i">
                <!-- 标签显示区域 -->
                <div
                  class="tag-container"
                  v-if="schemaData[t] && schemaData[t].length"
                >
                  <el-tag
                    v-for="(tag, index) in schemaData[t]"
                    :key="index"
                    style="margin-bottom: 10px"
                    :closable="true"
                    @close="removeTag(index, t)"
                  >
                    {{ tag }}
                  </el-tag>
                </div>
                <!-- 添加按钮 -->
                <el-button
                  type="primary"
                  @click="fnShowInput(i)"
                  v-if="!$data[`isInputShow${i}`]"
                  class="addtag-btn"
                  style="height: 32px;margin-bottom: 10px"
                >
                  <i class="el-icon-plus"></i> 添加标签
                </el-button>

                <!-- 动态输入框（点击添加按钮后显示） -->
                <el-input
                  v-else
                  style="width: 200px"
                  v-model="$data[`newTag${i}`]"
                  placeholder="输入标签并按回车"
                  size="small"
                  @keyup.enter.native="addTag(i,t)"
                  @blur="addTag(i,t)"
                  :ref="`creatTagInputRef${i}`"
                >
                </el-input>
              </el-form-item>
            </template>
            
            <!-- 多个上传文件回显 -->
            <!-- <template v-for="(t,i) in ['mp4', 'zip']"   :slot="`fileListSlot${t}`" > -->
            <template v-for="(t,i) in schemaBasicInfo.imageListSlotArr"   :slot="`fileListSlot${t}`" >
              <div :key="i" class="file-list-box">
                <div
                  class="file-list-item"
                  v-for="(item, index) in schemaData[t]"
                  :key="index"
                >
                    <!-- 图片 -->
                    <div class="file-list-content" v-if="formattedData(item,'suffix') == 'jpg' || formattedData(item,'suffix') == 'jpeg' || formattedData(item,'suffix') == 'png' || formattedData(item,'suffix') == 'gif' ">
                      <img :src="item" class="file-list-img" />
                      <i class="el-icon-error deleteIcon imgdeleteIcon" @click="fnRemove(index,'imageList',t)"></i>
                    </div>
                    <!-- 视频 -->
                    <div class="file-list-content" v-if="formattedData(item,'suffix') == 'mp4'">
                      <video :src="item" controls class="file-list-video">
                      </video>
                      <i class="el-icon-error deleteIcon imgdeleteIcon" @click="fnRemove(index,'imageList',t)"></i>
                    </div>
                    <!-- 音频 -->
                    <div class="file-list-content" v-if="formattedData(item,'suffix') == 'mp3'">
                      <div class="file-list-audio">
                        <span>{{ formattedData(item,'name') }}</span>
                        <audio :src="item" controls class="audio"></audio>
                      </div>
                      <i class="el-icon-error deleteIcon imgdeleteIcon" @click="fnRemove(index,'imageList',t)"></i>
                    </div>
                    <!-- zip、excel -->
                    <div class="file-list-content" v-if="formattedData(item,'suffix') == 'zip' || formattedData(item,'suffix') == 'xlsx' ">
                      <a :href="encodeURI(item)" :download="formattedData(item,'name')" class="file-list-zip">
                        <i class="el-icon-tickets icon-zip"></i> 
                        <span>{{ formattedData(item,'name') }}</span>
                      </a>
                      <i class="el-icon-error deleteIcon imgdeleteIcon" @click="fnRemove(index,'imageList',t)"></i>
                    </div>
                    <div class="file-list-content" style="border: 1px dashed #c0ccda;" v-loading="true" v-if="!item"></div>
                </div>
              </div>
            </template>

            <!-- 单个上传文件回显，注意动态插槽写法 -->
            <!-- <template v-for="(t,i) in ['mp3', 'tv', 'phone']"   :slot="`fileSingleSlot${t}`" > -->
            <template v-for="(t,i) in schemaBasicInfo.imageSingleSlotArr"   :slot="`fileSingleSlot${t}`" >
              <div :key="i" class="file-single-box">
                <div class="file-single-item" v-if="schemaData[t]">
                  <!-- 图片 -->
                  <div class="file-list-content" v-if="formattedData(schemaData[t],'suffix') == 'jpg' || formattedData(schemaData[t],'suffix') == 'jpeg' || formattedData(schemaData[t],'suffix') == 'png' || formattedData(schemaData[t],'suffix') == 'gif' ">
                    <img :src="schemaData[t]" class="file-list-img" />
                    <i class="el-icon-error deleteIcon imgdeleteIcon" @click="fnRemove(0,'imageSingle',t)"></i>
                  </div>
                  <!-- 视频 -->
                  <div class="file-list-content" v-if="formattedData(schemaData[t],'suffix') == 'mp4'">
                    <video :src="schemaData[t]" controls class="file-list-video">
                    </video>
                    <i class="el-icon-error deleteIcon imgdeleteIcon" @click="fnRemove(0,'imageSingle',t)"></i>
                  </div>
                  <!-- 音频 -->
                  <div class="file-list-content" v-if="formattedData(schemaData[t],'suffix') == 'mp3'">
                    <div class="file-list-audio">
                      <span>{{ formattedData(schemaData[t],'name') }}</span>
                      <audio :src="schemaData[t]" controls class="audio"></audio>
                    </div>
                    <i class="el-icon-error deleteIcon imgdeleteIcon" @click="fnRemove(0,'imageSingle',t)"></i>
                  </div>
                  <!-- zip、excel -->
                  <div class="file-list-content" v-if="formattedData(schemaData[t],'suffix') == 'zip' || formattedData(schemaData[t],'suffix') == 'xlsx' ">
                    <a :href="encodeURI(schemaData[t])" :download="formattedData(schemaData[t],'name')" class="file-list-zip">
                      <i class="el-icon-tickets icon-zip"></i> 
                      <span>{{ formattedData(schemaData[t],'name') }}</span>
                    </a>
                    <i class="el-icon-error deleteIcon imgdeleteIcon" @click="fnRemove(0,'imageSingle',t)"></i>
                  </div>
                </div>
                <!-- 设置宽高，让loading居中显示，因为 file-single-box 子元素脱离文档流，不占空间 -->
                <div style="border: 1px solid red;width: 148px;height: 148px;margin-left: 20px;position: absolute;" v-loading="true" v-if="schemaData[t]=='empty'"></div>
              </div>
            </template>
          </schema-form>
        </div>
      </el-card>
    </el-form>
  </section>
</template>

<script>
import { uploadFile } from "../api/comment";

export default {
  name: 'schemaFormCommon',
  props: {
    schemaData: Object,
    schemaConfig: Array,
    schemaRules: Object,
    schemaBasicInfo: Object,
    schemaOptions: Object,
  },
  data() {
    const isInputShowObj = {};
    for (let i = 0; i <= 10; i++) {
      isInputShowObj[`isInputShow${i}`] = false; // 动态添加属性 isInputShow0、isInputShow1、......isInputShow10
    }
    const newTagObj = {};
    for (let i = 0; i <= 10; i++) {
      newTagObj[`newTag${i}`] = ""; // 动态添加属性 newTag0、newTag1、.....newTag10
    }

    return {
      layout: {
        // gutter:0
      },
      ...isInputShowObj, // isInputShow: false,  输入标签的input框是否显示， 定义多个
      ...newTagObj, // newTag: "",  输入标签的input框绑定的值，定义多个
      uploadingCount: {} // 记录上传索引，格式如 { mp4: 0 }
    };
  },
  created() {
  },
  methods: {
    /* 新建 tag 开始 */
    // 显示input输入框
    fnShowInput(i) {
      this[`isInputShow${i}`] = true
      this.$nextTick(() => {
        this.$refs[`creatTagInputRef${i}`][0].focus();
      });
    },
    // 添加标签
    addTag(i,t) {
      const tag = this[`newTag${i}`].trim();
      if (tag) {
        this.schemaData[t].push(tag);
      }
      this.resetAddState(i);

      console.log(111, this.schemaData);
    },
    // 重置状态 出现添加标签,隐藏输入标签的输入框
    resetAddState(i) {
      this[`isInputShow${i}`] = false;
      this[`newTag${i}`] = "";
    },

    // 删除标签
    removeTag(index, prop) {
      this.schemaData[prop].splice(index, 1);
    },
    /* 新建 tag 结束 */

    // 文件上传前拦截处理
    beforeUpload(file) {
      console.log(123,file)
      // 限制文件上传格式
      let fileName = file.name;
      let suffix = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
      const isZIP = suffix === "zip";
      const isGIF = suffix === "gif";
      const isPNG = suffix === "png";
      const isMP4 = suffix === "mp4";
      const isMP3 = suffix === "mp3";
      const isExcel = suffix === "xlsx";
      const isJpg = suffix === 'jpg' || suffix === 'jpeg'

      if (!(isZIP || isPNG || isJpg || isGIF || isMP4 || isMP3 || isExcel)) {
        this.$message.error("请按规定格式上传文件");
        return false; // 返回false阻止文件上传
      }

      // 限制文件上传大小
      const maxSize = 3;
      const size = file.size / 1024 / 1024; // 将文件大小转换为MB
      if (size > maxSize) {
        this.$message.error(`上传文件大小不能超过 ${maxSize}MB！`);
        return false; // 返回false阻止文件上传
      }
    },

    // 上传图片
    customRequest(params, imageType, prop) {
      let tIndex
      if (imageType == "imageList") {
        // 记录上传索引
        if (this.uploadingCount[prop] === undefined) {
          this.uploadingCount[prop] = this.schemaData[prop].length; // 兼容创建、修改 ，创建时是0，修改时是对应的数组长度
        }else {
          this.uploadingCount[prop]++;
        }

        tIndex = this.uploadingCount[prop]

        // 上传前，添加空字符串作为loading，上传完，用图片把loading替换掉
        this.schemaData[prop] = this.schemaData[prop].concat(['']);
      }
      

      if (imageType == "imageSingle") {
        this.schemaData[prop] = 'empty'
      }

      const formData = new FormData()
      formData.append('file', params.file)
      uploadFile(formData)
        .then((res) => {
          // 上传单张图片赋值
          if (imageType == "imageSingle") {
            this.schemaData[prop] = res.data
          }

          // 上传多张图片赋值
          if (imageType == "imageList") {
            this.schemaData[prop].splice(tIndex,1,res.data)
          }

          // 上传完的图片右上角有个 √ 这样的小图标
          params.onSuccess({ url: res.data });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message || "上传失败",
            duration: 5000,
            showClose: true,
          });
          params.onError(err);
        })
      return false;
    },
    // 删除图片
    fnRemove(index,imageType,prop) {
      // 单张上传后删除
      if(imageType == 'imageSingle') {
        this.schemaData[prop] = '';
      }

      // 多张上传后删除
      if(imageType == 'imageList') {
        this.schemaData[prop].splice(index, 1);
        this.uploadingCount[prop]-- // 同步上传索引
      }
    },
    formattedData(url,type) {
      if(url && typeof url == 'string') {
        let suffix = url.substring(url.lastIndexOf(".") + 1).toLowerCase();
        let name = url.slice(-6)
        let value = type == 'suffix' ? suffix : name
        return value
      }
    },
    validate(callback) {
      //这个ruleFormRef是子组件内部el-form 的ref="ruleFormRef"    valid=>boolean  errorFields => 报错信息，没有报错，返回{}
      this.$refs.ruleFormRef.validate((valid, errorFields) => {
        // console.log('errorFields--',errorFields)
        let errorMsg = '';
        for (const key in errorFields) {
          const fieldErrors = errorFields[key];
          errorMsg = fieldErrors[0].message;
          break
        }
          
        callback(valid,errorMsg)

        // callback(valid)
      })
    },
  }
};
</script>

<style scoped>
.card {
  margin-bottom: 20px;
}

.el-tag {
  margin-right: 10px;
}

/* 隐藏 本地预览图片中间的删除图标 */
::v-deep .el-upload-list__item.is-ready .el-icon-delete {
  display: none !important;
}
/* 隐藏 本地预览图片中间的删除图标 */
::v-deep .el-upload-list__item.is-ready .el-upload-list__item-actions {
  display: none !important;
}

/* 自定义上传按钮 */
::v-deep .el-upload--picture-card {
  position: relative;
}
::v-deep .el-upload--picture-card::before {
  /* 图标字体内容 */
  content: "\e6d9";
  font-family: "element-icons";
  font-size: 36px;
  font-weight: normal;
  color: #999;
}

 ::v-deep .el-form-item__content {
  display: flex;
 }

.file-list-box,.file-single-box {
  /* display: grid;
  grid-template-columns: repeat(auto-fill, 148px); 
  gap: 20px;   */
  display: flex;
  flex-wrap: wrap;
  margin-left: -20px;
  margin-right: 20px;
  position: relative;
}

.file-list-item {
  width: 148px;
  height: 148px;
  margin-left: 20px;
  margin-bottom: 20px;
}

.file-single-item {
  position: absolute;
  z-index: 10;
  width: 148px;
  height: 148px;
  margin-left: 20px;
  margin-bottom: 20px;
}

.file-list-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.file-list-img,.file-list-video,.file-list-audio,.file-list-zip {
  width: 100%;
  height: 100%;
}

.file-list-zip,.file-list-audio {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  background: white;
  border: 1px dotted grey;
}

.file-list-audio .audio {
  width: 100%;
  height: 30px;
}

.deleteIcon {
  font-size: 20px;
  color: red;
  cursor: pointer;
}

.icon-zip {
  font-size: 30px;
}

::v-deep .imgdeleteIcon {
  position: absolute;
  top: -8px;
  right: -8px;
}


/* 关键：通过子元素 .el-form-item[prop="xxx"] 反选父级 el-col */
::v-deep .el-col:has( div[class="single-file"]) {
  width: 148px !important; 
  margin-right: 20px !important; 
  /* border: 1px solid red; */
}

</style>